import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  wrapContentSection: {
    paddingTop: 24,
  },
}));

export default useStyles;
